


































import { Component, Vue, Inject } from 'vue-property-decorator';
import Footer from '../components/Footer.vue'
import iView from 'iview';
import AbpBase from '../lib/abpbase'
import Ajax from '../lib/ajax'
import util from "../lib/util";
import { resolve } from 'url';
@Component({
  name:'login',
  components:{Footer}
})
export default class Login extends AbpBase {
    $Message:any
    $store:any
    $Modal:any
    loginModel={
        userNameOrEmailAddress:'',
        password:'',
        rememberMe:false
    }
    showChangeTenant:boolean=false
    async login(){
        localStorage.removeItem('autoBool');
        (this.$refs.loginform as any).validate(async (valid:boolean)=>{
        if(valid){
                this.$Message.loading({
                    content: '登录中',
                    duration:0
                })
                await this.$store.dispatch({
                    type:'app/login',
                    data:this.loginModel
                })
                sessionStorage.setItem('rememberMe',this.loginModel.rememberMe?'1':'0');
                Ajax.get('/AbpUserConfiguration/GetAll').then(res => {
                    if(Object.keys(res.data.result.auth.grantedPermissions).length) {
                            location.reload();
                    } else {
                        this.$store.commit("app/logout", this);
                        util.abp.auth.clearToken();
                        location.reload();
                    }
                })
        }
        });
    }
    rules={
        userNameOrEmailAddress: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
        ]
    }
    async created(){
    }
}
